import { inject, provide, ref, type InjectionKey, type Ref } from 'vue';

const KEY: InjectionKey<Ref<boolean>> = Symbol('counterparty-master-step-ready');

export function provideCounterpartyMasterStepReady() {
  const stepReady = ref(false);
  provide(KEY, stepReady);
  return stepReady;
}

export function useCounterpartyMasterStepReady() {
  return inject(KEY, ref(true));
}
